module.exports = __webpack_public_path__ + "static/media/laravel-plain-wordmark.14fd8fbf.svg";